export const arrayBufferToBase64 = (buffer: ArrayBuffer | null) => {
  // Check if the buffer is defined
  if (!buffer) return "";

  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
};
